import * as React from 'react'
import Helmet from 'react-helmet'
import 'lazysizes'

import TeamProfiles from '../../components/TeamNew/TeamProfiles'
import Header from '../../components/Header'
import Footer from '../../components/core/Footer'
import MentorsandStrategicAdvisors from '../../components/TeamNew/MentorsandStrategicAdvisors'
import LandingSection from '../../components/TeamNew/LandingSection'
import ApplicationSection from '../../components/TeamNew/ApplicationSection'
import FollowUsSection from '../../components/TeamNew/FollowUsSection'
import darkTheme from '../../constants/themeConstants/darkTheme'
import {
  TitleContainer,
  Title,
  TitleUnderLine
} from '../../components/TeamNew/TeamProfiles/styledComponents'
import AdvisoryCouncilSection from '../../components/TeamNew/AdvisoryCouncilSection'

type Props = {
  isBookNowSlotOpened: boolean,
  bookNowModalData: any,
  data: any
}

class Team extends React.Component<Props> {
  render() {
    const {
      data,
      headerPropsData,
      footerProps,
      isBookNowSlotOpened,
      bookNowModalData
    } = this.props

    if (data) {
      const { teamPageData } = data
      const {
        title,
        seoData,
        gamingAdvisoryCouncilData,
        coreTeamData,
        mentorsGroupAdvisorsTeamData,
        developmentServicesData,
        trainingsData,
        applicationSectionData
      } = teamPageData.edges[0].node.frontmatter

      return (
        <div>
          <Helmet>
            <title>{seoData.title}</title>
            <meta name="description" content={seoData.metaDescription} />
            <meta property="og:title" content={seoData.ogTitle} />
            <meta property="og:url" content={seoData.ogWebsiteUrl} />
            {/* <meta
              property="og:image"
              content="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/ibc-social-images/iBC-twitter-image.jpg"
            /> */}
            <meta property="og:description" content={seoData.ogDescription} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="ib.cricket" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" content={seoData.twitterTitle} />
            <meta name="twitter:url" content="https://ib.cricket/our-team/" />
            <meta name="twitter:site" content="@playiBCricket" />
            <meta
              property="twitter:description"
              content={seoData.twitterdescription}
            />
            {/* <meta
              name="twitter:image"
              content="https://s3.ap-south-1.amazonaws.com/proyuga-media-assets/ibc-social-images/iBC-twitter-image.jpg"
            /> */}
          </Helmet>
          <Header
            isBookNowSlotOpened={isBookNowSlotOpened}
            bookNowModalData={bookNowModalData}
            headerPropsData={headerPropsData}
          />
          <LandingSection />
          <TitleContainer>
            <Title as="h2">{title}</Title>
            <TitleUnderLine />
          </TitleContainer>
          <AdvisoryCouncilSection
            gamingAdvisoryCouncilData={gamingAdvisoryCouncilData}
          />
          <TeamProfiles coreTeamData={coreTeamData} />
          <MentorsandStrategicAdvisors
            mentorsGroupAdvisorsTeamData={mentorsGroupAdvisorsTeamData}
          />
          <ApplicationSection applicationSectionData={applicationSectionData} />
          <FollowUsSection
            stakeholdersList={developmentServicesData.servicesList}
            stakeholdersData={developmentServicesData}
          />
          <FollowUsSection
            stakeholdersData={trainingsData}
            stakeholdersList={trainingsData.trainingsList}
            invertTheme
          />
          <Footer {...footerProps} theme={darkTheme.footerSection} />
        </div>
      )
    }
    return null
  }
}

export default Team

// eslint-disable-next-line
export const teamGraphql = graphql`
  query teamGraphqlQuery {
    teamPageData: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/ourteam-page/" } }
    ) {
      edges {
        node {
          frontmatter {
            title
            seoData {
              title
              metaDescription
              ogTitle
              ogWebsiteUrl
              ogDescription
              twitterTitle
              twitterdescription
              twitterimage
            }
            gamingAdvisoryCouncilData {
              title
              manyMoreText
              councilMembersList {
                name
                designation
                imageUrl
              }
            }
            coreTeamData {
              heading
              manyMoreText
              teamMembersList {
                name
                college
                position
                picUrl
              }
            }
            mentorsGroupAdvisorsTeamData {
              heading
              mentorsGroupAdvisorsMembersList {
                name
                profilePic
                designation
              }
            }
            developmentServicesData {
              title
              servicesList {
                title
                description
                callToAction
                apply
                redirect
                imagePath
                sectionId
                mainImage
                mobileImage
              }
            }
            trainingsData {
              title
              sectionId
              trainingsList {
                title
                description
                callToAction
                apply
                redirect
                imagePath
                sectionId
                mainImage
                mobileImage
              }
            }
            applicationSectionData {
              title
              applicationsList {
                title
                imageUrl
                content
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/our-team/index.js